import { get } from "../modules/env";

import type { QueryInit } from "../types.d";

/**
 * Pared-down version of Apollo's gql tag to enable
 * formatting and highlighting. The request body is
 * converted to a DocumentNode by the receiving client.
 */
export function gql(chunks: TemplateStringsArray): string {
  return chunks.reduce((accumulator, chunk) => `${accumulator}${chunk}`, "");
}

/**
 * Fetches data from and API.
 */
export async function fetchData<T>(init: RequestInit = {}) {
  const url = get("API_URL");

  if (!url) {
    throw new Error(`API URL missing`);
  }

  const headers = new Headers(init.headers);

  headers.set("Content-Type", "application/json");

  const request = new Request(url, {
    ...init,
    mode: "cors",
    headers,
  });

  const response = await fetch(request).catch(() => ({
    ok: false,
    status: 400,
    url,
    json: async () => ({}),
  }));

  if (response.ok) {
    const data = await response.json?.();

    // Only cache if no errors were returned
    if (!data.errors?.length) {
      return data as T;
    }
  }

  throw new Error(
    `Application error code ${response.status} for "${response.url}"`,
  );
}

/**
 * Sends a GraphQL request to the API.
 */
export async function query<T>(
  init: QueryInit,
  reqInit?: Pick<RequestInit, "headers">,
) {
  return fetchData<T>({
    method: "POST",
    body: JSON.stringify(init),
    ...reqInit,
  });
}
